import { render, staticRenderFns } from "./ReviewRvmAllocations.vue?vue&type=template&id=1cfd9f06&"
import script from "./ReviewRvmAllocations.vue?vue&type=script&lang=js&"
export * from "./ReviewRvmAllocations.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRvmAllocations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports